export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-bookmark-a42e44dc42b0567075d7ee5c7832d639.svg";